"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toTip = exports.toSearchKey = exports.toSearchFilter = exports.toScript = exports.toOutPoint = exports.toCellOutPut = void 0;
const toTip = tip => ({
  blockHash: tip.block_hash,
  blockNumber: tip.block_number
});
exports.toTip = toTip;
const toScript = data => ({
  codeHash: data.code_hash,
  hashType: data.hash_type,
  args: data.args
});
exports.toScript = toScript;
const toOutPoint = data => ({
  txHash: data.tx_hash,
  index: data.index
});
exports.toOutPoint = toOutPoint;
const toCellOutPut = data => ({
  ...data,
  lock: toScript(data.lock),
  type: data.type ? toScript(data.type) : undefined
});
exports.toCellOutPut = toCellOutPut;
const toSearchFilter = data => {
  return {
    script: data.script ? toScript(data.script) : data.script,
    outputDataLenRange: data.output_data_len_range,
    outputCapacityRange: data.output_capacity_range,
    scriptLenRange: data.script_len_range,
    blockRange: data.block_range
  };
};
exports.toSearchFilter = toSearchFilter;
const toSearchKey = data => ({
  script: toScript(data.script),
  scriptType: data.script_type,
  filter: data.filter ? toSearchFilter(data.filter) : data.filter,
  scriptSearchMode: data.script_search_mode
});
exports.toSearchKey = toSearchKey;
//# sourceMappingURL=resultFormatter.js.map